import { useGetHiringAdviceListQuery } from 'src/graphql/generated';

import { useAccountContext } from './useAccountContext';

export const useHiringAdvice = () => {
  const { data: accountContext } = useAccountContext();
  const skip = !accountContext;

  // Even if accountContext is still null we need to call this hook
  // (with skip: true) to comply with the rule of hooks in React
  const { loading, error, data } = useGetHiringAdviceListQuery({
    skip,
  });

  return {
    // Force loading to come back as 'true' if we don't have the account info yet
    loading: skip || loading,
    error,
    data: data?.hirerDashboardHiringAdviceList?.articles,
  };
};
